<template>
  <div class="connect-internet-view default-page">
    <img
      :src="bannerImage"
      alt="connecting-internet"
      class="default-page__banner"
    />
    <h1>Підключити інтернет</h1>
    <div class="default-page-section">
      Ну дуже
      <span class="default-page-section__accent">швидкісний&nbsp;інтернет</span>
      з абонплатою від 99 грн та підключенням за 1 грн 🔥
    </div>
    <div class="default-page-section">
      📩 Залишайте заявку на підключення, і ми зателефонуємо Вам.
    </div>
    <div class="default-page-section mb-0">
      <app-phone-input
        v-model="form.phone"
        placeholder="+38(___)___-___-___"
        :error="v$.phone.$error ? v$.phone.$errors[0].$message : ''"
        @input="v$.phone.$touch()"
        @focus="handleInputState($event, true)"
        @blur="
          v$.phone.$touch();
          handleInputState($event, false);
        "
      />
      <app-btn
        class="btn btn-primary w-100"
        :disabled="v$.$invalid || isLoading"
        @click="submitForm"
      >
        <span v-if="!isLoading">Відправити заявку</span>
        <span
          v-else
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </app-btn>
      <div
        v-show="isShowAdditionalSpace"
        ref="additionalSpace"
        class="additional-space"
      ></div>
    </div>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";
import AppPhoneInput from "@/components/common/ui/AppPhoneInput.vue";
import { computed, nextTick, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import bannerImage from "@/assets/connect-internet/banner-internet.jpg";
import CrmConnector from "utelecomim-crmconnector";
import useVibration from "@/composition/UseVibration";
import { useStore } from "vuex";

export default {
  name: "ConnectInternetView",
  components: {
    AppBtn,
    AppPhoneInput,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { vibrate } = useVibration();
    const isShowAdditionalSpace = ref(false);
    const activeInputElement = ref(null);

    const form = reactive({
      phone: "",
    });

    const rules = {
      phone: {
        required: helpers.withMessage("Це поле обовʼязкове", required),
        valid: helpers.withMessage(
          "Невірний формат номера",
          helpers.regex(/^\+38\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/)
        ),
      },
    };

    const v$ = useVuelidate(rules, form);
    const isLoading = ref(false);

    const additionalSpace = ref(null);

    const isMobilePlatform = computed(() => store.getters.isMobilePlatform);

    const handleInputState = (event, value) => {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) return;
      if (value) {
        // focus
        activeInputElement.value = event.target;

        if (!isMobilePlatform.value) return;

        isShowAdditionalSpace.value = true;

        nextTick(() => {
          const inputRect = event?.target?.getBoundingClientRect?.();
          const spaceEl = additionalSpace.value;
          const spaceRect = spaceEl?.getBoundingClientRect?.();

          if (inputRect && spaceRect) {
            const distance =
              window.innerHeight - spaceRect.top + inputRect.top - 40;

            spaceEl.style.height = `${distance}px`;
          }

          nextTick(() => {
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: "smooth",
            });
          });
        });
      } else {
        // blur
        setTimeout(() => {
          // Якщо активний елемент не змінився на новий input — ховаємо
          if (event.target === activeInputElement.value) {
            isShowAdditionalSpace.value = false;
            activeInputElement.value = null;
          }
        }, 300);
      }
    };

    const submitForm = async () => {
      v$.value.$touch();
      if (v$.value.$invalid) return;

      isLoading.value = true;

      const connector = new CrmConnector("https://imapi.prosto.net", {
        timeout: 10000,
        headers: {},
      });

      try {
        const { code, message } = await connector
          .setTitle("Підключення")
          .setDescription("Заявка з телеграм додатку")
          .setPhone(form.phone.replace(/\D/g, ""))
          .setUserName("-")
          .setUtmSource("tgminiapp")
          .setTrademarkId(2)
          .send();
        console.log("code", code, "message", message);
        vibrate([50, 200, 100, 200, 200]);
        router.push({ name: "request-success" });
      } catch ({ code, message }) {
        console.log("code", code, "message", message);
        router.push({ name: "request-error" });
      } finally {
        form.phone = "";
        v$.value.$reset();
        isLoading.value = false;
      }
    };

    return {
      bannerImage,
      form,
      v$,
      isLoading,
      additionalSpace,
      isShowAdditionalSpace,
      handleInputState,
      submitForm,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins.less";
.connect-internet-view {
  .default-page-section__accent {
    .section-text-accent();
  }
}
</style>
